// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XRbs","delete":"styles_delete__2dbfO","update":"styles_update__34E63","add":"styles_add__eRXyq"};